//============================================================

// -- news

//============================================================

//MT Apiデータ取得
var news = {
  blogID: "",
  url: "",
  yearURL: "",
  api: "",
  html: "",
  siteId: "",
  for: 20, // お知らせを表示する数
  date: "", // 日付フォーマット変更
  icon: "", // icon
  pdfUrl: "", // icon
  sortList: $(".l-news__search-category li a"),
  sortSelect: $(".l-news__search-category select"),
  sortYear: $(".l-news__search-year select"),
  sortMore: $("#js__readmore"),
  loader: $(".c-news__loader"),
  category: "",
  sortDate: "",
  offset: 0,
  year: [],

  init: function (category) {
    // session(category,offset)
    if ("sessionStorage" in window && window.sessionStorage !== null) {
      if (
        category !== "" &&
        category !== null &&
        category !== undefined &&
        category !== "undefined"
      ) {
      } else if (
        sessionStorage.categorySession !== "" &&
        sessionStorage.categorySession !== null &&
        sessionStorage.categorySession !== undefined &&
        sessionStorage.categorySession !== "undefined"
      ) {
        category = sessionStorage.categorySession;
        let listNumber = ["37", "38", "39", "40", "41", "36"];
        let num = listNumber.indexOf(category);
        news.sortList.parent().removeClass("current");
        $(".l-news__search-category")
          .find("li")
          .eq(num + 1)
          .addClass("current");
      }
      //session 更新
      sessionStorage.setItem("categorySession", category);
      window.sessionStorage.setItem("categorySession", category);
      sessionStorage.categorySession = category;
      if (
        sessionStorage.offsetSession !== "" &&
        sessionStorage.offsetSession !== 0 &&
        sessionStorage.offsetSession !== null &&
        sessionStorage.offsetSession !== undefined &&
        sessionStorage.offsetSession !== "undefined"
      ) {
        news.offset = sessionStorage.offsetSession;
        news.for = parseInt(sessionStorage.offsetSession) + 20;
      }
    }

    //date
    if (news.sortYear.find("option:selected")[0]) {
      news.sortDate = news.sortYear.find("option:selected").val();
    }

    if ($("#p-news")[0]) {
      news.blogID = 8;
    } else if ($("#p-ir")[0]) {
      news.blogID = 23;
    }
    news.sortMore.hide();
    if (
      category !== "" &&
      category !== null &&
      category !== undefined &&
      category !== "undefined" &&
      news.blogID === 8
    ) {
      news.url =
        "/corporate/corp_admin/mt/mt-data-api.cgi/v2/sites/" +
        news.blogID +
        "/categories/" +
        Number(category) +
        "/entries?limit=500";
      //news.url = "/mt/mt-data-api.cgi/v2/sites/"+news.blogID+"/categories/"+Number(category)+"/entries?limit=500";
    } else {
      news.url =
        "/corporate/corp_admin/mt/mt-data-api.cgi/v2/sites/" +
        news.blogID +
        "/entries?limit=500";
      //news.url = "/mt/mt-data-api.cgi/v2/sites/"+news.blogID+"/entries?limit=500";
    }

    $.ajax({
      url: news.url,
      type: "GET",
      dataType: "json",
    })
      .done(function (data) {
        news.clone(data);

        let arg = new Object();
        let pair = location.search.substring(1).split("&");
        for (let i = 0; pair[i]; i++) {
          let kv = pair[i].split("=");
          arg[kv[0]] = kv[1];
        }
      })
      .fail(function (data) {
        news.loader.addClass("hide");
        news.sortMore.hide();
      });
  },

  clone: function (data) {
    // reset
    news.html = "";
    let newsLength = 0;

    let clone = function (entry) {
      //entry.customFields[0] = PDF entry.customFields[1] = 外部リンク entry.customFields[2] = リンク先 entry.customFields[3] = アイコン
      if (
        entry.customFields[0].value !== "" &&
        entry.customFields[0].value !== null
      ) {
        news.pdfUrl = entry.customFields[0].value;
        news.pdfUrl = news.pdfUrl.split('<a href="');
        news.pdfUrl = news.pdfUrl[1].split('">');
        news.pdfUrl = news.pdfUrl[0];
        news.icon =
          '<svg version="1.1" class="c-news__icon c-news__icon-pdf" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40.122px" height="13px" viewBox="0 0 40.122 13" enable-background="new 0 0 40.122 13" xml:space="preserve"><path fill="#131A27" d="M9,1v11H1V1H9 M10,0H0v13h10V0L10,0z"/><rect x="4" y="3" fill="#131A27" width="5" height="1.979"/><path fill="#111926" d="M19.902,3.024h2.858c1.669,0,2.679,0.989,2.679,2.438c0,1.619-1.26,2.459-2.829,2.459h-1.169v2.099h-1.539V3.024z M22.66,6.552c0.77,0,1.22-0.459,1.22-1.079c0-0.69-0.479-1.06-1.249-1.06h-1.189v2.139H22.66z"/><path fill="#111926" d="M26.582,3.024h2.729c2.198,0,3.718,1.509,3.718,3.498c0,1.969-1.52,3.498-3.718,3.498h-2.729V3.024zM29.311,8.632c1.259,0,2.108-0.85,2.108-2.109c0-1.239-0.85-2.109-2.108-2.109h-1.189v4.218H29.311z"/><path fill="#111926" d="M34.402,3.024h5.327v1.399h-3.788v1.489h3.338v1.399h-3.338v2.709h-1.539V3.024z"/></svg>';
      } else if (
        entry.customFields[2].value !== "" &&
        entry.customFields[2].value !== null
      ) {
        if (entry.customFields[2].value.match(/.pdf/)) {
          news.pdfUrl = entry.customFields[2].value;
          news.icon =
            '<svg version="1.1" class="c-news__icon c-news__icon-pdf" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40.122px" height="13px" viewBox="0 0 40.122 13" enable-background="new 0 0 40.122 13" xml:space="preserve"><path fill="#131A27" d="M9,1v11H1V1H9 M10,0H0v13h10V0L10,0z"/><rect x="4" y="3" fill="#131A27" width="5" height="1.979"/><path fill="#111926" d="M19.902,3.024h2.858c1.669,0,2.679,0.989,2.679,2.438c0,1.619-1.26,2.459-2.829,2.459h-1.169v2.099h-1.539V3.024z M22.66,6.552c0.77,0,1.22-0.459,1.22-1.079c0-0.69-0.479-1.06-1.249-1.06h-1.189v2.139H22.66z"/><path fill="#111926" d="M26.582,3.024h2.729c2.198,0,3.718,1.509,3.718,3.498c0,1.969-1.52,3.498-3.718,3.498h-2.729V3.024zM29.311,8.632c1.259,0,2.108-0.85,2.108-2.109c0-1.239-0.85-2.109-2.108-2.109h-1.189v4.218H29.311z"/><path fill="#111926" d="M34.402,3.024h5.327v1.399h-3.788v1.489h3.338v1.399h-3.338v2.709h-1.539V3.024z"/></svg>';
        } else if (entry.customFields[2].value.match(/http/)) {
          news.pdfUrl = entry.customFields[2].value;
          news.icon =
            '<svg class="c-news__icon c-news__icon-blank" xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="5.5 -12 16 13"><path fill="#131A27" d="M20.5-11v8h-11v-8m12-1h-13v10h13"/><path fill="#131A27" d="M6.469.031v-7.015H5.5V1h10.969V.031z"/></svg>';
        } else {
          news.pdfUrl = entry.customFields[2].value;
          news.icon =
            '<svg version="1.1" class="c-news__icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"y="0px" width="20.946px" height="11.668px" viewBox="0 0 20.946 11.668" enable-background="new 0 0 20.946 11.668" xml:space="preserve"><line fill="none" stroke="#131A27" stroke-miterlimit="10" x1="0" y1="5.834" x2="20" y2="5.834"/><polyline fill="none" stroke="#131A27" stroke-miterlimit="10" points="15.337,11.334 20.274,5.834 15.337,0.334"/></svg>';
        }
      } else {
        news.pdf = false;
        news.icon =
          '<svg version="1.1" class="c-news__icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"y="0px" width="20.946px" height="11.668px" viewBox="0 0 20.946 11.668" enable-background="new 0 0 20.946 11.668" xml:space="preserve"><line fill="none" stroke="#131A27" stroke-miterlimit="10" x1="0" y1="5.834" x2="20" y2="5.834"/><polyline fill="none" stroke="#131A27" stroke-miterlimit="10" points="15.337,11.334 20.274,5.834 15.337,0.334"/></svg>';
      }
      news.html += '<article class="c-news__list">';
      if (
        entry.customFields[0].value !== "" &&
        entry.customFields[0].value !== null
      ) {
        news.html += '<a href="' + news.pdfUrl + '" target="_blank">';
      } else if (
        entry.customFields[2].value !== "" &&
        entry.customFields[2].value !== null
      ) {
        if (
          entry.customFields[2].value.match(/.pdf/) ||
          entry.customFields[2].value.match(/http/)
        ) {
          news.html += '<a href="' + news.pdfUrl + '" target="_blank">';
        } else {
          news.html += '<a href="' + news.pdfUrl + '">';
        }
      } else {
        news.html += '<a href="' + entry.permalink + '">';
      }
      news.html += '<div class="c-news__info">';
      news.html += '<time class="c-news__time">' + news.date + "</time>";
      if (entry.categories[0]) {
        news.html +=
          '<p class="c-news__category">' + entry.categories[0].label + "</p>";
      }
      news.html += "</div>";
      news.html += '<div class="c-news__list-text">';
      news.html += "<p>" + entry.title + "</p>";
      news.html += "</div>";
      news.html += news.icon;
      news.html += "</a>";
      news.html += "</article>";
    };
    //一覧を生成
    let i;
    let mach = 0;
    let entry;
    let _length = data.items.length;

    for (i = 0; i < _length; i++) {
      entry = data.items[i];
      //日付フォーマット変更
      news.date = entry.date.split("T");
      news.date = news.date[0].replace(/-/g, ".");
      if (news.sortDate !== "" && news.sortDate !== null) {
        if (news.date.indexOf("" + news.sortDate + "") != -1) {
          if (mach >= news.offset) {
            clone(entry);
            newsLength++;
          }
          mach++;
        }
      } else {
        if (i >= news.offset) {
          clone(entry);
          newsLength++;
        }
      }

      if (newsLength === news.for) {
        break;
      }
    }
    if (newsLength < 20) {
      news.sortMore.hide();
      if (newsLength === 0 && news.offset === 0) {
        news.html += "<p>記事がありません</p>";
      }
    } else {
      news.sortMore.show();
    }
    $("#entries").append(news.html);
    news.loader.addClass("hide");
  },

  yearSelect: function (data) {
    let i;
    let entry;
    let _length = data.items.length;
    let key = 0;

    //年で絞り込む部分の変更
    //reset
    news.year = [];
    news.sortYear.empty();
    //add
    news.sortYear.append('<option value="">年で絞り込む</option>');
    for (i = 0; i < _length; i++) {
      if (news.year.indexOf(parseInt(data.items[i].date.split("-", 1))) == -1) {
        news.year[key] = parseInt(data.items[i].date.split("-", 1));
        news.sortYear.append(
          '<option value="' +
            news.year[key] +
            '">' +
            news.year[key] +
            "年</option>"
        );
        key++;
      }
    }
    news.sortYear.val(news.sortDate);
  },

  sort: function () {
    let sort = function () {
      if (news.category != "" && news.category != null && news.blogID === 8) {
        news.url =
          "/corporate/corp_admin/mt/mt-data-api.cgi/v2/sites/" +
          news.blogID +
          "/categories/" +
          news.category +
          "/entries?limit=500";
        //news.url = "/mt/mt-data-api.cgi/v2/sites/"+news.blogID+"/categories/"+news.category+"/entries?limit=500&offset="+news.offset+"";
        if (news.blogID === 8)
          news.yearURL =
            "/corporate/corp_admin/mt/mt-data-api.cgi/v2/sites/" +
            news.blogID +
            "/categories/" +
            news.category +
            "/entries?limit=500";
      } else {
        news.url =
          "/corporate/corp_admin/mt/mt-data-api.cgi/v2/sites/" +
          news.blogID +
          "/entries?limit=500";
        //news.url = "/mt/mt-data-api.cgi/v2/sites/"+news.blogID+"/entries?limit=500&offset="+news.offset+"";
        if (news.blogID === 8)
          news.yearURL =
            "/corporate/corp_admin/mt/mt-data-api.cgi/v2/sites/" +
            news.blogID +
            "/entries?limit=500";
      }

      news.loader.removeClass("hide");
      $.ajax({
        url: news.url,
        type: "GET",
        dataType: "json",
      })
        .done(function (data) {
          news.clone(data);
        })
        .fail(function (data) {
          news.loader.addClass("hide");
          news.sortMore.hide();
        });
      if (news.blogID === 8) {
        $.ajax({
          url: news.yearURL,
          type: "GET",
          dataType: "json",
        })
          .done(function (data) {
            news.yearSelect(data);
          })
          .fail(function (data) {});
      }
    };

    //category
    let category = function (_index) {
      news.sortList.parent().removeClass("current");
      news.sortList.eq(_index).parent().addClass("current");
      news.sortSelect.children("option").eq(_index).prop("selected", true);
      // session(category)
      if ("sessionStorage" in window && window.sessionStorage !== null) {
        sessionStorage.setItem("categorySession", news.category);
        window.sessionStorage.setItem("categorySession", news.category);
        sessionStorage.categorySession = news.category;
      }
      $("#entries").empty();
      //オフセット、表示する件数をreset
      news.offset = 0;
      news.for = 20;
      sessionStorage.setItem("offsetSession", 0);
      window.sessionStorage.setItem("offsetSession", 0);
      sessionStorage.offsetSession = 0;
      sort();
      return false;
    };
    news.sortList.on("click", function () {
      //年をリセット
      news.sortDate = "";
      let _index = $(this).parent().index();
      news.category = $(this).data("sortcategory");
      category(_index);
    });
    news.sortSelect.change(function () {
      //年をリセット
      news.sortDate = "";
      let _index = news.sortSelect.children("option:selected").index();
      news.category = news.sortSelect.children("option:selected").val();
      category(_index);
    });

    //date
    news.sortYear.change(function () {
      news.sortDate = news.sortYear.find("option:selected").val();
      $("#entries").empty();
      //オフセット、表示する件数をreset
      news.offset = 0;
      news.for = 20;
      sessionStorage.setItem("offsetSession", 0);
      window.sessionStorage.setItem("offsetSession", 0);
      sessionStorage.offsetSession = 0;
      sort();
      return false;
    });

    //more
    news.sortMore.on("click", function () {
      news.offset = parseInt(news.offset) + 20;
      if ("sessionStorage" in window && window.sessionStorage !== null) {
        sessionStorage.setItem("offsetSession", news.offset);
        window.sessionStorage.setItem("offsetSession", news.offset);
        sessionStorage.offsetSession = news.offset;
      }
      sort();
      return false;
    });
  },
};

if ($("#p-news .c-news")[0] || $("#p-ir .c-news")[0]) {
  if ($("#p-ir .c-news")[0]) {
    //お知らせ以外のページに行ったらsession削除
    if ("sessionStorage" in window && window.sessionStorage !== null) {
      sessionStorage.setItem("categorySession", "");
      window.sessionStorage.setItem("categorySession", "");
      sessionStorage.categorySession = "";
      sessionStorage.setItem("offsetSession", 0);
      window.sessionStorage.setItem("offsetSession", 0);
      sessionStorage.offsetSession = 0;
    }
  }
  news.sort();
  let param = location.search;
  let listNumber = ["37", "38", "39", "40", "41", "36"];
  let category;
  if (param !== "") {
    param = location.search.substring(1).split("&");
    param = param[0].split("=");
    param = param[1];
    param = listNumber.indexOf(param);
    news.sortList.parent().removeClass("current");
    $(".l-news__search-category")
      .find("li")
      .eq(param + 1)
      .addClass("current");
    category = listNumber[param];
    news.init(category);
  } else {
    news.init("");
  }
} else {
  //お知らせ以外のページに行ったらsession削除
  if ("sessionStorage" in window && window.sessionStorage !== null) {
    if (
      sessionStorage.categorySession === undefined &&
      sessionStorage.offsetSession === undefined
    ) {
    } else {
      sessionStorage.setItem("categorySession", "");
      window.sessionStorage.setItem("categorySession", "");
      sessionStorage.categorySession = "";
      sessionStorage.setItem("offsetSession", 0);
      window.sessionStorage.setItem("offsetSession", 0);
      sessionStorage.offsetSession = 0;
    }
  }
}
